import { authorizedHttpGet, httpPut } from "./httpCalls";
import urls from "./urls.json";

const dataUrlToBlob = (dataUrl) => {
    const [meta, base64Str] = dataUrl.split(",");
    const mimeMatch = meta.match(/data:(.*);base64/);
    const contentType = mimeMatch ? mimeMatch[1] : "image/jpeg";
    const binary = atob(base64Str);
    const len = binary.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    return {
        blob: new Blob([bytes], { type: contentType }),
        contentType,
    };
};

const uploadToPresignedUrlWithRetry = async (presignedUrl, blob, headers) => {
    const maxAttempts = 3;
    let lastUploadResp = null;

    for (let attempt = 1; attempt <= maxAttempts; attempt++) {
        const uploadResp = await httpPut(presignedUrl, blob, headers);
        lastUploadResp = uploadResp;

        if (uploadResp.status) {
            return uploadResp;
        }
    }

    console.error("S3 upload retry attempts exhausted:", lastUploadResp?.error || lastUploadResp);
    return { status: false };
};

// Uses admin/images/fetch_presigned_url and uploads to S3.
// Expects response: { presigned_url, image_url }.
// Returns image_url (GET URL) for storing in state.
// `ref` is the profile ref, forwarded to the backend for logging/association.
export const uploadCroppedImageToS3 = async (dataUrl, ref) => {
    try {
        const { blob, contentType } = dataUrlToBlob(dataUrl);
        console.log("Image content type", contentType)

        const presignResp = await authorizedHttpGet(
            urls.GET_PRESIGNED_IMAGE_URL,
            { ref, image_replaced: true }
        );

        if (!presignResp.status) {
            alert("Failed to get presigned URL");
            throw new Error("presigned_url_error");
        }
        
        console.log("presign resp:", presignResp.data)

        const [{ presigned_url, image_url }] = presignResp.data;

        const uploadResp = await uploadToPresignedUrlWithRetry(
            presigned_url,
            blob,
            { "Content-Type": "image/png" }
        );

        if (!uploadResp.status) {
            alert("Failed to upload image to storage");
            throw new Error("s3_upload_error");
        }

        return image_url;
    } catch (error) {
        console.error("Error in uploadCroppedImageToS3:", error);
        alert("An error occurred while uploading the image. Please try again.");
        return null;
    }
};
